import React, { useState } from 'react';
import ProfileForm from '../components/Profile/ProfileForm';
import UserTicketHistory from '../components/Profile/UserTicketHistory';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';
import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: ${props => props.padding};
  background: ${props => props.theme.background};

  /* Custom Scrollbar - Discord Theme */
  &::-webkit-scrollbar {
    width: 16px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.backgroundSecondary};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.cardBackgroundHover};
    border-radius: 8px;
    border: 4px solid ${props => props.theme.backgroundSecondary};
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${props => props.theme.border};
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${props => props.theme.cardBackgroundHover} ${props => props.theme.backgroundSecondary};

  @media (max-width: 768px) {
    padding: 0.5rem;
  }
`;

const TabContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const TabButtons = styled.div`
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid ${props => props.theme.border};

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const TabButton = styled.button`
  padding: 12px 24px;
  border: 1px solid ${props => props.theme.border};
  background: ${props => props.active ? props.theme.buttonPrimary : props.theme.background};
  color: ${props => props.active ? props.theme.text : props.theme.textSecondary};
  cursor: pointer;
  font-size: 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
  margin-right: 0.5rem;

  &:hover {
    background: ${props => props.active ? props.theme.buttonPrimary : props.theme.cardBackgroundHover};
    border-color: ${props => props.theme.buttonPrimary};
  }

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 0.5rem;
  }
`;

const TabContent = styled.div`
  background: ${props => props.theme.backgroundSecondary};
  border: 1px solid ${props => props.theme.border};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  overflow: hidden;
`;

const Profile = () => {
  const { user } = useAuth();
  const { settings } = useData();
  const [activeTab, setActiveTab] = useState('profile');

  const isPremium = (user?.subscription && user?.subscription !== 'free') || (user?.aiTier && user?.aiTier !== 'free');
  const isCompact = isPremium && settings?.display?.compactMode;
  const padding = isCompact ? '0.125rem' : '0.75rem';

  return (
    <Container padding={padding}>
      <TabContainer>
        <TabButtons>
          <TabButton
            active={activeTab === 'profile'}
            onClick={() => setActiveTab('profile')}
          >
            Profile Settings
          </TabButton>
          <TabButton
            active={activeTab === 'support'}
            onClick={() => setActiveTab('support')}
          >
            Support Tickets
          </TabButton>
        </TabButtons>

        <TabContent>
          {activeTab === 'profile' && <ProfileForm compact={isCompact} />}
          {activeTab === 'support' && <UserTicketHistory />}
        </TabContent>
      </TabContainer>
    </Container>
  );
};

export default Profile;